import { countries } from "@/ts/countries";
import { applicationCategory, applicationType } from "@/types/applicationType";
import { setCity, setCountry, setPostalCode, setProvince, setStreetDirection, setStreetName, setStreetNumber, setStreetType, setUnitNumber, setUnitType } from "@/slices/homeAddressSlice";
import { americanStates } from "@/ts/americanStates";
import { streetTypes } from "@/ts/streetTypes";
import { setPhoneNumber, setTitle, setFirstName, setLastName, setSin, setCitizenshipStatus, setFirstTimeBuyer, setRecentResident, setResidentStatus, setResidenceYears, setResidenceMonths, setIdVerificationStatus, setAlloySessionId, setIdvId, setTwilioResultCodeVerified, setEmailAddress } from "@/slices/applicantSlice";
import { setApplicationCategory, setSearchingForProperty, setTermLength, setAmortizationLength, setDownPayment, setIsCoApplicant, setApplicationProgress, setWelcomeEmailSent, setApplicationEndpointReached, setIdVerificationSubmitted, setAlloyApplicationToken, setUnderStaffReview, setPurchaseTypeSelected, setJointAccepted, setJointCode, setJointPrimaryApplicant, setJointRelationship, setApplicationId, setTotalLoan } from "@/slices/applicationSlice";
import { coapplicant, addCoApplicant } from "@/slices/coApplicantSlice";
import { addressInfo, addPreviousAddress } from "@/slices/PreviousAddressSlice";
import { setPAStreetNumber, setPAStreetName, setPAUnitNumber, setPACity, setPAProvince, setPAPostalCode, setPACountry, setPAStreetDirection, setPAStreetType } from "@/slices/propertyAddressSlice";
import { setPropertyValue, setPurchasePrice, setOriginalPurchasePrice, setMortgageBalance, setMortgageHolder, setPropertyTax, setLivableArea, setLivableAreaUnit, setHeatingCost, setHeatingType, setMaintenanceFee, setPurposeOfProperty, setRentOut, setSeparateUnit, setOwnOtherRentalProperties, setNumOfRentalProperties, setNumOfRentalUnits, setClosingDate, setFundingDate, setFinancingConditionExists, setFinancingConditionDate } from "@/slices/propertyInfoSlice";
import { AnyAction } from "@reduxjs/toolkit";
import { Dispatch } from "react";
import { setEmploymentStatus, setEmploymentType, setEmploymentIncome, setPayrollFrequency, setPayrollType, setOccupation } from "@/slices/employmentSlice";
import { setAMLFieldsCompleted } from "@/slices/legalTermsSlice";
import dayjs from "dayjs";
import { addPreviousEmployment, employmentInfo, toggleNoPreviousEmployment } from "@/slices/previousEmploymentSlice";
import { setReferralProducts } from "@/slices/referralProductSlice";
import { applicantType } from "@/types/applicantType";
import { OnlineAccountDetailType } from "./DTMWebAPIClient.generated";
interface validateDateReturn {
  hasError: boolean;
  errorMessage: string;
  invalidYear: boolean;
  invalidDay: boolean;
}

export const validateAge = (dob: string) => {
  const resultObj: validateDateReturn = { hasError: false, errorMessage: "", invalidYear: false, invalidDay: false };

  //Check if dob is a valid one
  let invalidDateFields = isValidDate(dob);
  if (invalidDateFields.length != 0) {
    resultObj.hasError = true;
    resultObj.errorMessage =
      "Please enter a valid date.";
    resultObj.invalidYear = invalidDateFields.includes(1);
    resultObj.invalidDay = invalidDateFields.includes(2);
  } else {
    let dobDate = +new Date(dob)
    let age = Math.floor(+((Date.now() - dobDate) / (24 * 3600 * 365.25 * 1000)));

    if (age < 18) {
      resultObj.hasError = true;
      resultObj.errorMessage = "Date of birth cannot be less than 18 years.";
      resultObj.invalidYear = true;
      resultObj.invalidDay = true;
    }
  }


  return resultObj;
};

//Return Values: [] (Valid Date), [1](Invalid Year), [2](Invalid Day), [1, 2] (Invalid Year and Day)
export const isValidDate = (date: string): number[] => {
  let errors = [];
  var parts = date.split("/");
  var year = parseInt(parts[0], 10);
  var month = parseInt(parts[1], 10);
  var day = parseInt(parts[2], 10);

  // Check the ranges of month and year
  if (year < 1900 || year > new Date().getFullYear() || month == 0 || month > 12) {
    errors.push(1);
  }

  var monthLengths = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  // Account for Leap years
  if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
    monthLengths[1] = 29;

  if (day > monthLengths[month - 1]) {
    errors.push(2);
  }
  // return day > 0 && day <= monthLengths[month - 1];
  return errors;
}

export const trimOptionText = (option: any, length: number) => {
  let optionText = "";
  if (option != undefined && option.length > length) {
    optionText = option.slice(0, length) + "...";
  } else {
    optionText = option;
  }

  return optionText;
};

export const isValidTin = (tin: string): boolean => {
  let valid = true;

  if (tin.trim().length == 0 && tin.includes(' ')) {
    console.log('only spaces');
    valid = false
  }

  const regex = new RegExp(/^[a-zA-Z0-9 '-.]*$/);


  if (!regex.test(tin)) {
    valid = false;
    return valid;
  }

  return valid;
};

export const isValidSSN = (ssn: string): boolean => {
  let isValidSSN = true;

  const regex = new RegExp(/^\d{3}-?\d{2}-?\d{4}$/);
  const hyphenCount = (ssn.match(/-/g) || []).length;

  if (!regex.test(ssn) || hyphenCount != 2) {
    isValidSSN = false;
  }

  return isValidSSN;
}
export const isValidSin = (sin: string): boolean => {
  let valid = true;

  //Allow for the following SIN formats: XXX-XXX-XXX, XXX XXX XXX & XXXXXXXXX
  const regex = new RegExp(/^(\d{3} \d{3} \d{3})|(\d{9})$/);


  if (!regex.test(sin)) {
    valid = false;
    return valid;
  }

  let sinNum = +(sin.replaceAll("-", "").replaceAll(" ", ""));

  if (sinNum.toString().startsWith("9")) {
    valid = false;
    return valid;
  }

  if (sinNum < 0 || sinNum > 999999998 || sinNum.toString().startsWith("8") || Number.isNaN(sinNum)) {
    valid = false;
    return valid;
  } else {
    let checksum = 0;
    for (let i = 4; i != 0; i--) {
      checksum += sinNum % 10 | 0;
      sinNum = (sinNum / 10) | 0;
      let addend = (2 * (sinNum % 10)) | 0;
      if (addend >= 10) addend -= 9;
      checksum += addend;
      sinNum = (sinNum / 10) | 0;
    }

    if ((checksum + sinNum) % 10 == 0) {
      valid = true;
      return valid;
    } else {
      valid = false;
      return valid;
    }
  }
};

export const countryList = (excludeNorthAmerica: boolean = false, limitToNorthAmerica: boolean = false) => {
  return countries.map((country) => {
    const countryName = trimOptionText(country.name, 24);

    if (excludeNorthAmerica) {
      if (countryName.toLowerCase() === "canada" || (countryName.toLowerCase() === "united states")) {
        return undefined
      }
    }
    if (limitToNorthAmerica) {
      if (countryName.toLowerCase() !== "canada" && (countryName.toLowerCase() !== "united states")) {
        return undefined
      }
    }

    return (
      <option key={country.name} value={country.name} title={country.name}>
        {countryName}
      </option>
    );
  });
};

export const americanStateList = () => {
  return americanStates.map((state) => {
    const stateName = trimOptionText(state.name, 24);

    return (
      <option key={state.name} value={state.code} title={state.name}>
        {stateName}
      </option>
    );
  });
};

export const americanStatesAbbreviationList = () => {
  return americanStates.map((state) => {
    return (state.code);
  });
};

export const streetTypeList = () => {
  return streetTypes.map((type) => {
    return (
      <option key={type} value={type} title={type}>
        {type}
      </option>
    );
  });
};

export const isCredentialsSectionActive = (pathName: string) => {
  const profileSection = [
    "create-profile",
    "phone-verification",
    "verification-code",
  ];

  return profileSection.find((section) => pathName.includes(section));
};

export const isProfileSectionActive = (pathName: string) => {
  const profileSection = [
    "personal-info",
    "co-applicant",
    "address",
    "employment",
    "assets"
  ];

  return profileSection.find((section) => pathName.includes(section));
};

export const isAddressSectionActive = (pathName: string) => {
  const addressSection = ["address"];

  return addressSection.find((section) => pathName.includes(section));
};

export const isConfirmProductActive = (pathName: string) => {
  const confirmProductSection = ["confirmproducts", "/single/sin"];

  return confirmProductSection.find((section) => pathName.includes(section));
};

export const isFinalizeAccountActive = (pathName: string) => {
  const finalizeAccountSection = ["finalizeaccount", "legalterms", "reviewapplication", "reviewterms", "review-application"];

  return finalizeAccountSection.find((section) => pathName.includes(section));
};

export const isCoapplicantSectionActive = (pathName: string) => {
  const coapplicantSection = ["co-applicant"];

  return coapplicantSection.find((section) => pathName.includes(section));
};

export const isHomeDetailsSectionActive = (pathName: string) => {
  const homeDetailsSection = ["property-details", "property-purpose", "financing-condition"];

  return homeDetailsSection.find((section) => pathName.includes(section));
};

export const isApplicationCreated = (pathName: string) => {
  const isCompleted = ["confirmapplication", "verifyidentification"];

  return isCompleted.find((section) => pathName.includes(section));
}

export const isMortgageSectionActive = (pathName: string) => {
  const mortgageSection = ["select-application", "mortgage", "select-assessment", "mortgage-term", "amortization", "closing-date", "funding-date",
    "purchase-price", "down-payment", "mortgage-term", "property-value"];

  return mortgageSection.find((section) => pathName.includes(section));
};

export const isVerifyIdentitySectionActive = (pathName: string) => {
  const verifySection = [
    "accept-terms",
    "process-summary",
    "choose-documents",
    "phone-process",
    "phone-connect",
    "verify-identification"
  ];

  return verifySection.find((section) => pathName.includes(section));
};

export const isLegalSectionActive = (pathName: string) => {
  const profileSection = [
    "legal-terms",
  ];

  return profileSection.find((section) => pathName.includes(section));
};

export const transformProvince = (province: string) => {
  if (province == "Alberta") return "AB";
  if (province == "British Columbia") return "BC";
  if (province == "Ontario") return "ON";
  if (province == "Quebec") return "QC";
  if (province == "Manitoba") return "MB";
  if (province == "Saskatechewan") return "SK";
  if (province == "Nova Scotia") return "NS";
  if (province == "Prince Edward Island") return "PE";
  if (province == "Newfoundland and Labrador") return "NL";
  if (province == "Northwest Territories") return "NT";
  if (province == "Yukon") return "YT";
  if (province == "Nunavut") return "NU";
  if (province == "New Brunswick") return "NB";

  return province;
}


export const setClickInsightFormErrors = (errors: Object): void => {

  let errorArr: string[] = [];
  for (const [key, value] of Object.entries(errors)) {
    errorArr.push(value.message);
  }
  if (errorArr.length > 0) {
    (window as any).dataLayer.push({
      'event': 'validationError',
      'errorMessages': errorArr
    });
  }
}

export const setClickInsightManualFormErrors = (errors: string[]): void => {
  if (errors.length > 0) {
    (window as any).dataLayer.push({
      'event': 'validationError',
      'errorMessages': errors
    });
  }
}

export const setClickInsightServiceError = (errorType?: string) => {

  (window as any).dataLayer.push({
    'event': 'serviceError',
    'errorMessages': [errorType != undefined ? errorType : 'service connection error']
  });

}

export const setClickInsightEventsNoState = (
  product: OnlineAccountDetailType | undefined,
  applicantInfo: applicantType,
  flowControl?: string,
  applicantType?: string,
  applicationOutCome?: string): void => {

  //if (account == undefined || account === null) return;

  console.log(applicantInfo);
  if (flowControl === undefined) {
    (window as any).dataLayer.push({
      'event': 'pageLoadData',
      'isMember': '' + !applicantInfo.isProspect,
      'productId': product ? product.productID + '' : '',
      'productName': product ? product.description + '' : '',
      'productType': 'Mortgage'
    });

    (window as any).dataLayer.push({
      'event': 'pageview',
      'pageUrl': window.location.href,
      'pageTitle': document.title
    });
  }

  if (flowControl) {
    if (flowControl.toLowerCase() == 'applicationstart') {
      (window as any).dataLayer.push({
        'event': flowControl,
        'applicantType': applicantType,
        'applicationStatus': applicationOutCome
      });
      (window as any).dataLayer.push({
        'event': 'pageLoadData',
        'productId': product ? product.productID + '' : '',
        'productName': product ? product.description + '' : '',
        'productType': 'Mortgage'
      });

    } else if (flowControl.toLowerCase() == 'applicationsuccess') {
      (window as any).dataLayer.push({
        'event': flowControl,
        'applicationOutcome': applicationOutCome + '',
        'productId': product ? product.productID + '' : '',
        'productName': product ? product.description + '' : '',
        'applicantType': window.location.href.includes('Joint') ? 'co-applicant' : 'primary applicant'
      });
    }


  }
}

export const setSingleClickInsightEvent = (
  eventType: string,
  result?: string,
  selectedOption?: string
): void => {

  if (result === undefined && selectedOption === undefined) {
    (window as any).dataLayer.push({
      'event': eventType
    });
    return;
  }

  if (selectedOption === undefined) {
    (window as any).dataLayer.push({
      'event': eventType,
      'result': result
    });
    return;
  }

  (window as any).dataLayer.push({
    'event': eventType,
    'result': result,
    'text': selectedOption
  });
}

export const setClickInsightApplicationProgress = (
  name: string
): void => {
  (window as any).dataLayer.push({
    'event': 'applicationStepComplete',
    'name': name
  });
}

export const setClickInsightOptionSelected = (
  event: string,
  selectedOption: string
): void => {
  (window as any).dataLayer.push({
    'event': event,
    'text': selectedOption
  });
}

export const setClickInsightEvents = (
  referralProducts: OnlineAccountDetailType[],
  flowControl?: string,
  applicationType?: string,
  applicationStatus?: string,
  applicationOutcome?: string,
  applicationId?: number,
  applicantInfo?: applicantType): void => {

  let product: OnlineAccountDetailType | undefined = referralProducts.length > 0 ? referralProducts[0] : undefined;

  if (flowControl === undefined) {
    (window as any).dataLayer.push({
      'event': 'pageLoadData',
      'isMember': '' + !applicantInfo?.isProspect,
      'productId': '' + (product ? product.productID : ''),
      'productName': '' + (product ? product.description : ''),
      'productType': 'Mortgage',
    });

    (window as any).dataLayer.push({
      'event': 'pageview',
      'pageUrl': window.location.href,
      'pageTitle': document.title
    });
  }

  if (flowControl) {

    let dataLayerObj = {
      'event': flowControl,
      'applicantType': applicationType ? applicationType : 'main',
      'applicationStatus': applicationStatus ? applicationStatus : 'new'
    };

    if (flowControl.toLowerCase() == "applicationstart") {
      (window as any).dataLayer.push(dataLayerObj);
    } else if (flowControl.toLowerCase() == "applicationsuccess" || flowControl.toLowerCase() == "applicationfailure" || flowControl.toLowerCase() == "applicationflowcomplete") {
      (window as any).dataLayer.push({
        ...dataLayerObj,
        'applicationOutcome': applicationOutcome,
        'applicantId': '' + applicantInfo?.id,
        'applicationId': '' + applicationId
      });
    }
  }
}

const generateRandomString = (length: number): string => {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters[randomIndex];
  }
  return result;
}

export const generateSessionId = (isJoint: boolean): string => {
  const code = generateRandomString(8);
  return `MCUDTM-${code}-${isJoint ? "C" : "P"}`;
}


export const processUserAppData = (data: any, dispatch: Dispatch<AnyAction>, isProspect: boolean) => {
  if (data.applicant != undefined) {
    let applicantInfo = data.applicant;
    dispatch(setPhoneNumber(applicantInfo == undefined ? "" : applicantInfo.phoneNumber));
    dispatch(setTitle(applicantInfo == undefined ? "" : applicantInfo.title));
    dispatch(setFirstName(applicantInfo == undefined ? "" : applicantInfo.firstName));
    dispatch(setLastName(applicantInfo == undefined ? "" : applicantInfo.lastName));
    dispatch(setEmailAddress(applicantInfo == undefined ? "" : applicantInfo.email));
    dispatch(setSin(applicantInfo == undefined ? "" : applicantInfo.sin));
    dispatch(setCitizenshipStatus(applicantInfo == undefined ? "" : applicantInfo.citizenshipStatus));
    dispatch(setFirstTimeBuyer(applicantInfo == undefined ? false : applicantInfo.firstTimeBuyer));
    dispatch(setRecentResident(applicantInfo == undefined ? false : applicantInfo.recentResident));
    dispatch(setTwilioResultCodeVerified(true));
    dispatch(setResidentStatus(applicantInfo == undefined ? "" : applicantInfo.residentStatus));
    dispatch(setResidenceYears(applicantInfo == undefined ? "" : applicantInfo.residenceYears));
    dispatch(setResidenceMonths(applicantInfo == undefined ? "" : applicantInfo.residenceMonths));
    dispatch(setIdVerificationStatus(applicantInfo == undefined ? "" : applicantInfo.idVerificationStatus))
    dispatch(setAlloySessionId(applicantInfo == undefined ? "" : applicantInfo.alloySessionId))
    dispatch(setIdvId(applicantInfo == undefined ? 0 : applicantInfo.idvId))
  }

  if (data.employment != undefined) {
    let employmentInfo = data.employment;
    dispatch(setEmploymentStatus(employmentInfo == undefined ? "" : employmentInfo.employmentStatus));
    dispatch(setEmploymentType(employmentInfo == undefined ? "" : employmentInfo.employmentType));

    dispatch(setOccupation(employmentInfo == undefined ? "" : employmentInfo.occupation));

    dispatch(setPayrollType(employmentInfo == undefined ? "" : employmentInfo.payrollType));
    dispatch(setEmploymentIncome(employmentInfo == undefined ? 0 : +employmentInfo.income));
    dispatch(setPayrollFrequency(employmentInfo == undefined ? "" : employmentInfo.payrollFrequency));
  }

  if (data.application != undefined) {
    let applicationInfo = data.application;
    if (applicationInfo.applicationCategory != undefined && applicationInfo.applicationCategory != 0) {
      dispatch(setApplicationCategory(applicationInfo.applicationCategory === 1 ? applicationCategory.Buy
        : applicationInfo.applicationCategory === 2 ? applicationCategory.Refinance : applicationCategory.Transfer));
    }
    dispatch(setSearchingForProperty(applicationInfo.searchingForProperty));
    dispatch(setPurchaseTypeSelected(applicationInfo.purchaseTypeSelected));
    if (applicationInfo.id == 0) {
      dispatch(setTermLength(applicationInfo.termLength));
      dispatch(setAmortizationLength(applicationInfo.amortizationLength));
      dispatch(setDownPayment(applicationInfo.downPayment));
      dispatch(setTotalLoan(applicationInfo.totalLoan));
    }

    //Retrieve Deal ID from app data if co-applicant hasn't accepted the deal yet
    if (!applicationInfo.jointAccepted && applicationInfo.id != 0) {
      dispatch(setApplicationId(applicationInfo.id));
    }

    dispatch(setApplicationProgress(applicationInfo.applicationProgress));
    dispatch(setWelcomeEmailSent(applicationInfo.welcomeEmailSent));
    dispatch(setApplicationEndpointReached(applicationInfo.applicationEndpointReached));

    dispatch(setAlloyApplicationToken(applicationInfo.alloyApplicationToken));
    dispatch(setIdVerificationSubmitted(applicationInfo.idVerificationSubmitted));
    dispatch(setUnderStaffReview(applicationInfo.underStaffReview));
    if (applicationInfo.jointCode != undefined && applicationInfo.jointCode != "") {
      dispatch(setJointCode(applicationInfo.jointCode));
    }
    if (applicationInfo.jointRelationship != undefined && applicationInfo.jointRelationship != "") {
      dispatch(setJointRelationship(applicationInfo.jointRelationship));
    }
    if (applicationInfo.jointPrimaryApplicant != undefined && applicationInfo.jointPrimaryApplicant != "") {
      dispatch(setJointPrimaryApplicant(applicationInfo.jointPrimaryApplicant));
    }
    dispatch(setJointAccepted(applicationInfo.jointAccepted));
  }

  if (data.previousEmployment != undefined) {
    let previousEmployment: employmentInfo[] =
      data.previousEmployment.employments;
    previousEmployment.forEach((p) => {
      dispatch(addPreviousEmployment(p));
    });
    if (data.previousEmployment.noPreviousEmployment) {
      dispatch(toggleNoPreviousEmployment(true));
    }
  }

  if (data.propertyInfo != undefined) {
    let propertyInfo = data.propertyInfo;
    dispatch(setPropertyValue(propertyInfo.propertyValue));
    if (data.application != undefined && data.application.id == 0) {
      dispatch(setPurchasePrice(propertyInfo.purchasePrice));
      dispatch(setOriginalPurchasePrice(propertyInfo.originalPurchasePrice));
      dispatch(setMortgageBalance(propertyInfo.mortgageBalance));
    }
    dispatch(setMortgageHolder(propertyInfo.mortgageHolder));
    dispatch(setPropertyTax(propertyInfo.propertyTax));
    dispatch(setLivableArea(propertyInfo.livableArea));
    dispatch(setLivableAreaUnit(propertyInfo.livableAreaUnit));
    dispatch(setHeatingCost(propertyInfo.heatingCost));
    dispatch(setHeatingType(propertyInfo.heatingType));
    dispatch(setMaintenanceFee(propertyInfo.maintenanceFee));

    dispatch(setPurposeOfProperty(propertyInfo.purposeOfProperty));
    dispatch(setRentOut(propertyInfo.rentOut));
    dispatch(setSeparateUnit(propertyInfo.separateUnit));
    dispatch(setOwnOtherRentalProperties(propertyInfo.ownOtherRentalProperties));
    dispatch(setNumOfRentalProperties(propertyInfo.numOfRentalProperties));
    dispatch(setNumOfRentalUnits(propertyInfo.numOfRentalUnits));
    dispatch(setClosingDate(propertyInfo.closingDate));
    dispatch(setFundingDate(propertyInfo.fundingDate));
    dispatch(setFinancingConditionExists(propertyInfo.financingConditionExists));
    dispatch(setFinancingConditionDate(propertyInfo.financingConditionDate));
  }

  if (data.homeAddress != undefined) {
    let homeAddress = data.homeAddress;
    dispatch(setStreetNumber(homeAddress.streetNumber));
    dispatch(setStreetName(homeAddress.streetName));
    dispatch(setStreetType(homeAddress.streetType));
    dispatch(setStreetDirection(homeAddress.streetDirection));
    dispatch(setUnitType(homeAddress.unitType));
    dispatch(setUnitNumber(homeAddress.unitNumber));
    dispatch(setCity(homeAddress.city));
    dispatch(setProvince(homeAddress.province));
    dispatch(setPostalCode(homeAddress.postalCode));
    dispatch(setCountry(homeAddress.country));
  }

  if (data.previousAddresses != undefined) {
    let previousAddresses: addressInfo[] =
      data.previousAddresses;
    previousAddresses.forEach((p) => {
      dispatch(addPreviousAddress(p));
    });
  }

  if (data.coapplicants != undefined) {
    let coapplicants: coapplicant[] = data.coapplicants;
    coapplicants.forEach((c) => {
      dispatch(addCoApplicant(c));
    });
  }

  if (data.propertyAddress != undefined) {
    let propertyAddress = data.propertyAddress;
    dispatch(setPAStreetNumber(propertyAddress.streetNumber));
    dispatch(setPAStreetName(propertyAddress.streetName));
    dispatch(setPAStreetType(propertyAddress.streetType));
    dispatch(setPAStreetDirection(propertyAddress.streetDirection));
    dispatch(setPAUnitNumber(propertyAddress.unitNumber));
    dispatch(setPACity(propertyAddress.city));
    dispatch(setPAProvince(propertyAddress.province));
    dispatch(setPAPostalCode(propertyAddress.postalCode));
    dispatch(setPACountry(propertyAddress.country));
  }

  if (data.legalTerms != undefined) {
    dispatch(setAMLFieldsCompleted(isProspect ? data.legalTerms?.fieldsCompleted : true));
  };

  if (data.referralProducts != undefined) {
    dispatch(setReferralProducts(data.referralProducts));
  } else {
    if (data.application != undefined) {
      let applicationInfo = data.application;
      dispatch(setIsCoApplicant(applicationInfo.isCoApplicant));
    }
  }
}

export const displayDateString = (dateJs: dayjs.Dayjs): string => {


  if (!dateJs.isValid()) return "";

  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  let monthText = monthNames[dateJs.month()];
  let dateString = `${dateJs.date().toString().length > 1 ? dateJs.date() : "0" + dateJs.date()} ` + monthText + ` ${dateJs.year()}`

  return dateString;
}

export const addBusinessDays = (days: number): dayjs.Dayjs => {
  const today = dayjs();
  let targetDate = today;

  for (let i = 0; i < days; i++) {
    targetDate = targetDate.add(1, 'day');

    var holidayExists = isHoliday(targetDate);

    // Skip weekends and Holidays
    while (targetDate.day() === 0 || targetDate.day() === 6 || holidayExists) {
      targetDate = targetDate.add(1, 'day');

      holidayExists = isHoliday(targetDate);
    }
  }

  return targetDate;
}

export const isHoliday = (targetDate: dayjs.Dayjs): boolean => {
  //New Year's Day
  if (targetDate.month() === 0 && targetDate.date() === 1) {
    return true;
  }

  //Family Day (3rd Monday in February)
  if (targetDate.month() === 1 && targetDate.day() === 1 && targetDate.date() >= 15 && targetDate.date() <= 21) {
    return true;
  }

  //Good Friday
  if (targetDate.month() === 3 && targetDate.day() === 5 && targetDate.date() >= 15 && targetDate.date() <= 21) {
    return true;
  }

  //Canada Day
  if (targetDate.month() === 6 && targetDate.date() === 1) {
    return true;
  }

  //Civic Holiday (1st Monday in August)
  if (targetDate.month() === 7 && targetDate.day() === 1 && targetDate.date() <= 7) {
    return true;
  }

  //Labour Day (1st Monday in September)
  if (targetDate.month() === 8 && targetDate.day() === 1 && targetDate.date() <= 7) {
    return true;
  }

  //Thanksgiving Day (2nd Monday in October)
  if (targetDate.month() === 9 && targetDate.day() === 1 && targetDate.date() >= 8 && targetDate.date() <= 14) {
    return true;
  }

  //Christmas and Boxing Day
  if ((targetDate.month() === 11 && targetDate.date() === 25) || (targetDate.month() === 11 && targetDate.date() === 26)) {
    return true;
  }

  return false;
}

export const transformMonth = (month: string) => {
  switch (month) {
    case "01":
      return "Jan";
    case "02":
      return "Feb";
    case "03":
      return "Mar";
    case "04":
      return "Apr";
    case "05":
      return "May";
    case "06":
      return "Jun";
    case "07":
      return "Jul";
    case "08":
      return "Aug";
    case "09":
      return "Sep";
    case "10":
      return "Oct";
    case "11":
      return "Nov";
    case "12":
      return "Dec";
    default:
      return "";
  }
};

export const isMobileDevice = (): boolean => {
  const userAgent: string = navigator.userAgent || navigator.vendor;
  const regexs = [/(Android)(.+)(Mobile)/i, /BlackBerry/i, /iPhone|iPod/i, /Opera Mini/i, /IEMobile/i]
  return regexs.some((b) => userAgent.match(b))
}